<template>
  <section class="key-element">
    <h4 v-bind:style="{color: color}">{{percent.toFixed(0)}}%</h4>
    <h4 class="header">{{name}}</h4>
    <ProgressLine v-bind:percent="percent" v-bind:color="color"/>
    <h4 class="header">&#8370 {{value | currency }}</h4>
  </section>
</template>

<script>
import ProgressLine from "@/components/overdraft/Line.vue";
export default {
  name: "Key",
  components: {
    ProgressLine
  },
  props: {
    percent: [Number, String],
    color: String,
    name: String,
    value: [Number, String]
  }
};
</script>

<style>
</style>
